"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FETCH_CAMPAIGNS_LIMIT = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _hooks = require("@alycecom/hooks");

var _services = require("@alycecom/services");

var _reactRedux = require("react-redux");

var _features = require("../../../../Shared/store/features");

var _user = require("../../../../Shared/store/user/user.selectors");

var _ShowGiftListsSection = _interopRequireDefault(require("../../BatchesList/ShowGiftListsSection"));

var _BatchesList = _interopRequireDefault(require("../../BatchesList/BatchesList"));

var _EmptyListSearch = _interopRequireDefault(require("../../../../Shared/components/EmptyListSearch"));

var _EmptyCampaignsList = _interopRequireDefault(require("../../../../Shared/components/EmptyCampaignsList"));

var _useTrackGiftingFlow = require("../../../hooks/useTrackGiftingFlow");

var _EmptyList = _interopRequireDefault(require("../../../../Shared/components/EmptyList"));

var _CampaignsFilter = _interopRequireDefault(require("./CampaignsFilter"));

var _CampaignsGrid = _interopRequireDefault(require("./CampaignsGrid/CampaignsGrid"));

var _CampaignGridItem = _interopRequireDefault(require("./CampaignsGrid/CampaignGridItem"));

var _BudgetBasedCampaignGridItem = _interopRequireDefault(require("./CampaignsGrid/BudgetBasedCampaignGridItem"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FETCH_CAMPAIGNS_LIMIT = 15;
exports.FETCH_CAMPAIGNS_LIMIT = FETCH_CAMPAIGNS_LIMIT;
var styles = {
  title: {
    color: 'primary.main'
  }
};

var initialState = _services.campaignsEntityAdapter.getInitialState({
  pagination: {}
});

var combineResponse = function combineResponse(state, response) {
  return _objectSpread(_objectSpread({}, _services.campaignsEntityAdapter.upsertMany(state, response.data)), {}, {
    pagination: response.pagination
  });
};

function getBudgetAvailableForCampaignsTeam(campaign, userUtilizations) {
  var _userUtilizations$cam;

  return campaign && userUtilizations ? (_userUtilizations$cam = userUtilizations[campaign.team.id]) === null || _userUtilizations$cam === void 0 ? void 0 : _userUtilizations$cam.availableBudgetAmount : undefined;
}

var SelectCampaign = function SelectCampaign(_ref) {
  var _queryState$paginatio;

  var _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? {} : _ref$filters,
      onSelect = _ref.onSelect,
      onOpenBatch = _ref.onOpenBatch,
      availableCountryIds = _ref.availableCountryIds;
  var availableCountryIdsRef = (0, _react.useRef)(availableCountryIds);
  var dispatch = (0, _reactRedux.useDispatch)();
  var userId = (0, _reactRedux.useSelector)(_user.getUserId);

  var _useDebouncedSetState = (0, _hooks.useDebouncedSetState)(filters, 700),
      _useDebouncedSetState2 = (0, _slicedToArray2.default)(_useDebouncedSetState, 4),
      debouncedFilters = _useDebouncedSetState2[0],
      setFilters = _useDebouncedSetState2[1],
      isFiltersReady = _useDebouncedSetState2[3];

  var _useModalState = (0, _hooks.useModalState)(),
      isOpen = _useModalState.isOpen,
      handleOpen = _useModalState.handleOpen,
      handleClose = _useModalState.handleClose;

  var trackCampaignListFavouriteClicked = (0, _useTrackGiftingFlow.useCampaignsListSetFavoriteClicked)();

  var _useSetIsCampaignFavo = (0, _services.useSetIsCampaignFavouriteMutation)(),
      _useSetIsCampaignFavo2 = (0, _slicedToArray2.default)(_useSetIsCampaignFavo, 1),
      setIsCampaignFavourite = _useSetIsCampaignFavo2[0];

  var _useInfiniteQuery = (0, _services.useInfiniteQuery)(_services.appApi.endpoints.getCampaigns, initialState, {
    combineResponse
  }),
      fetchNext = _useInfiniteQuery.fetchNext,
      queryState = _useInfiniteQuery.queryState,
      setQueryState = _useInfiniteQuery.setQueryState,
      isIdle = _useInfiniteQuery.isUninitialized,
      isPending = _useInfiniteQuery.isFetching;

  var paginationTotal = (_queryState$paginatio = queryState.pagination) === null || _queryState$paginatio === void 0 ? void 0 : _queryState$paginatio.total;
  var isCanLoadMore = typeof paginationTotal !== 'number' || paginationTotal > queryState.ids.length;

  var _useGetBudgetUtilizat = (0, _services.useGetBudgetUtilizationByUserIdQuery)({
    userId
  }, {
    refetchOnMountOrArgChange: true
  }),
      budgetUtilization = _useGetBudgetUtilizat.data,
      isLoadingBudgetUtilization = _useGetBudgetUtilizat.isLoading,
      isFetchingBudgetUtilization = _useGetBudgetUtilizat.isFetching;

  (0, _react.useEffect)(function () {
    return function () {
      dispatch(_services.appApi.util.invalidateTags([{
        type: _services.CampaignsApiTag.Campaign,
        id: 'PARTIAL-LIST'
      }]));
    };
  }, [dispatch]);
  var fetchCampaigns = (0, _react.useCallback)(function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    fetchNext(function (currentState) {
      return _objectSpread(_objectSpread({}, debouncedFilters), {}, {
        countryIds: debouncedFilters !== null && debouncedFilters !== void 0 && debouncedFilters.countryIds && !!debouncedFilters.countryIds.length ? debouncedFilters.countryIds : availableCountryIdsRef.current,
        pagination: {
          offset: typeof params.offset === 'number' ? params.offset : currentState.ids.length,
          limit: FETCH_CAMPAIGNS_LIMIT
        }
      });
    }, {
      resetState: params.resetState || false
    });
  }, [debouncedFilters, fetchNext]);
  var fetchNextCampaigns = (0, _react.useCallback)(function () {
    fetchCampaigns();
  }, [fetchCampaigns]);
  (0, _react.useEffect)(function () {
    fetchCampaigns({
      offset: 0,
      resetState: true
    });
  }, [fetchCampaigns]);

  var _useState = (0, _react.useState)(new Set()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expandedCampaigns = _useState2[0],
      setExpandedCampaigns = _useState2[1];

  var toggleCampaignExpanding = (0, _react.useCallback)(function (id) {
    setExpandedCampaigns(function (currentValue) {
      if (currentValue.has(id)) {
        currentValue.delete(id);
      } else {
        currentValue.add(id);
      }

      return new Set(currentValue);
    });
  }, []);
  var search = debouncedFilters.search,
      countryIds = debouncedFilters.countryIds;
  var noRowsRenderer = (0, _react.useCallback)(function () {
    if (search) {
      return /*#__PURE__*/_react.default.createElement(_EmptyListSearch.default, {
        search: search
      });
    }

    if (countryIds !== null && countryIds !== void 0 && countryIds.length) {
      return /*#__PURE__*/_react.default.createElement(_EmptyCampaignsList.default, {
        message: "You don`t have any campaigns for recipients from selected countries."
      });
    }

    return /*#__PURE__*/_react.default.createElement(_EmptyList.default, null);
  }, [search, countryIds]);
  var handleUpdateFilters = (0, _react.useCallback)(function (value) {
    setFilters(function (currentFilters) {
      return _objectSpread(_objectSpread({}, currentFilters), value);
    });
  }, [setFilters]);
  var handleSetIsCampaignFavourite = (0, _react.useCallback)(function (campaignId, isFavourite) {
    setQueryState(function (currentState) {
      return _services.campaignsEntityAdapter.updateOne(currentState, {
        id: campaignId,
        changes: {
          isFavourite
        }
      });
    });
    trackCampaignListFavouriteClicked({
      campaignId,
      isSet: isFavourite
    });
    setIsCampaignFavourite({
      campaignId,
      body: {
        isFavourite
      }
    });
  }, [setIsCampaignFavourite, setQueryState, trackCampaignListFavouriteClicked]);
  var ids = queryState.ids,
      campaigns = queryState.entities;
  var hasBudgetManagementLimit = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BUDGET_MANAGEMENT_LIMIT));
  var hasBudgetManagementSetup = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BUDGET_MANAGEMENT_SETUP));
  var hasBudgetFeaturesEnabled = hasBudgetManagementLimit && hasBudgetManagementSetup;
  var isLoading = isPending || isIdle || !isFiltersReady || isLoadingBudgetUtilization;
  var isFiltersSet = (debouncedFilters === null || debouncedFilters === void 0 ? void 0 : debouncedFilters.countryIds) && !!debouncedFilters.countryIds.length || (debouncedFilters === null || debouncedFilters === void 0 ? void 0 : debouncedFilters.search);
  var isEmptyWithFilters = isFiltersSet && !ids.length;
  var isShowFiltersBlock = !!ids.length || isEmptyWithFilters;
  return isOpen && !!onOpenBatch ? /*#__PURE__*/_react.default.createElement(_BatchesList.default, {
    onBack: handleClose,
    onItemClick: onOpenBatch
  }) : /*#__PURE__*/_react.default.createElement(_material.Box, {
    height: 1,
    pt: 4,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    px: 3,
    flex: "0 0 auto"
  }, /*#__PURE__*/_react.default.createElement(_ShowGiftListsSection.default, {
    onShow: handleOpen
  }), isShowFiltersBlock && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.title,
    variant: "h4"
  }, "List of campaigns"), /*#__PURE__*/_react.default.createElement(_CampaignsFilter.default, {
    availableCountryIds: availableCountryIdsRef.current,
    onUpdate: handleUpdateFilters
  }))), /*#__PURE__*/_react.default.createElement(_CampaignsGrid.default, {
    renderItem: function renderItem(index, measure) {
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        my: 1,
        mx: 3
      }, hasBudgetFeaturesEnabled ? /*#__PURE__*/_react.default.createElement(_BudgetBasedCampaignGridItem.default, {
        measure: measure,
        onClick: onSelect,
        campaign: isFiltersReady ? campaigns[ids[index]] : undefined,
        onToggleExpand: toggleCampaignExpanding,
        expanded: !!campaigns[ids[index]] && expandedCampaigns.has(ids[index]),
        onChangeIsFavourite: handleSetIsCampaignFavourite,
        availableBudgetForCampaign: getBudgetAvailableForCampaignsTeam(campaigns[ids[index]], budgetUtilization === null || budgetUtilization === void 0 ? void 0 : budgetUtilization.entities),
        isLoading: isFetchingBudgetUtilization || isLoadingBudgetUtilization
      }) : /*#__PURE__*/_react.default.createElement(_CampaignGridItem.default, {
        measure: measure,
        onClick: onSelect,
        campaign: isFiltersReady ? campaigns[ids[index]] : undefined,
        onToggleExpand: toggleCampaignExpanding,
        expanded: !!campaigns[ids[index]] && expandedCampaigns.has(ids[index]),
        onChangeIsFavourite: handleSetIsCampaignFavourite
      }));
    },
    getIsItemFulfilled: function getIsItemFulfilled(_ref2) {
      var index = _ref2.index;
      return !!campaigns[ids[index]] && isFiltersReady;
    },
    canFetchMore: isCanLoadMore,
    fetchMore: fetchNextCampaigns,
    loading: isLoading,
    total: ids.length,
    renderEmpty: noRowsRenderer
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(SelectCampaign);

exports.default = _default;